import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Comment, COMMENT_TYPE, Meta } from 'utils/types';

import { commentsTransformers } from '../transformers';
import c from '../utils/constants';

interface Params {
  referenceId?: string;
  include?: string[];
  type?: COMMENT_TYPE;
  orderBy?: 'ASC' | 'DESC';
}

interface Result {
  data: Comment[];
  meta: Meta;
}

export default function useGetNotes(params: Params = {}) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<Comment[], Error>({
    queryKey: [c.NOTES, params?.referenceId, params.type, params.orderBy],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: '/api/v1/comments',
            params,
            transformer: commentsTransformers.comments,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/comments`,
            params,
            transformer: commentsTransformers.comments,
          },
        }),
      );

      return data?.data;
    },
  });
}
